export const loglevelConstants = {
    Info:0,
    Warning:1,
    Error:2
}